import { fetchJson } from './client';

export const auth = {
  login: (email: string, password: string) =>
    fetchJson<{ token: string; user: any }>('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  signup: (data: { email: string; password: string; name: string; enrollmentCode: string }) =>
    fetchJson<{ status: 'active' | 'pending'; message: string }>('/auth/signup', { method: 'POST', body: JSON.stringify(data) }),
  register: (data: { email: string; password: string; role?: string; name?: string }) =>
    fetchJson('/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  me: () => fetchJson<any>('/auth/me'),
  changePassword: (currentPassword: string, newPassword: string) =>
    fetchJson('/auth/change-password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword }) }),
};
